import React, { useState } from 'react';
import { useMessagesStore } from '../../../zustand/store';
import { sendInputFocusStatus } from '../../../utils/utils';
import styles from '../../../style/styles/PreQuestion.module.css';
import { validateInput } from '../InputFactory';

export const DoubleTextInput = ({
  order,
  question,
  fields,
  onAnswer,
  onNext,
}) => {
  const { setMessages } = useMessagesStore();
  const [firstInput, setFirstInput] = useState('');
  const [secondInput, setSecondInput] = useState('');
  const [inputValid, setInputValid] = useState([false, false]);
  const [errorMessage, setErrorMessage] = useState(['', '']);

  const validateInputs = () => {
    if (!firstInput || !secondInput) {
      setErrorMessage(['모든 필드를 입력해주세요', errorMessage[1]]);
      return false;
    }

    // 첫 번째 필드 검증
    const firstValidation = validateSingleInput(firstInput, fields[0].validation);
    if (!firstValidation.isValid) {
      setErrorMessage([firstValidation.message, errorMessage[1]]);
      return false;
    }

    // 두 번째 필드 검증
    const secondValidation = validateSingleInput(secondInput, fields[1].validation);
    if (!secondValidation.isValid) {
      setErrorMessage([errorMessage[0], secondValidation.message]);
      return false;
    }

    setErrorMessage(['', '']);
    return true;
  };

  const validateSingleInput = (value, validation) => {
    const min = validation?.min || 1;
    const max = validation?.max || 999;
    const numValue = Number(value);
    
    if (!value || value.length === 0) {
      return { isValid: false, message: '값을 입력해주세요' };
    }
    
    if (isNaN(numValue) || numValue < min || numValue > max) {
      return { 
        isValid: false, 
        message: `${min}~${max}까지 입력 가능합니다.` 
      };
    }
    
    return { isValid: true };
  };

  const handleFirstInputChange = (e) => {
    setFirstInput(e.target.value);
    setInputValid([validateInput('Text', e.target.value, fields[order]).isValid, inputValid[1]]);
    setErrorMessage([validateInput('Text', e.target.value, fields[order])?.message, errorMessage[1]]);
  };

  const handleSecondInputChange = (e) => {
    setSecondInput(e.target.value);
    setInputValid([inputValid[0], validateInput('Text', e.target.value, fields[order]).isValid]);
    setErrorMessage([errorMessage[0], validateInput('Text', e.target.value, fields[order])?.message]);
  };

  const handleButtonClick = () => {
    const isValid = validateInputs();
    if (!isValid) return;
    
    const combinedAnswer = `${firstInput}, ${secondInput}`;
    // 메시지에 추가
    setMessages([{ message: question, isChatbot: true }]);
    setMessages([{ message: combinedAnswer, isChatbot: false }]);
    
    // 답변 전달
    onAnswer({ key: fields[0].key, answer: firstInput }, order);
    onAnswer({ key: fields[1].key, answer: secondInput }, order);
    
    // 다음 단계로
    onNext();
  };

  const handleKeyPress = (e) => {
    e.stopPropagation();
    if (e.key === 'Enter') {
      e.preventDefault();
      handleButtonClick();
    }
  };

  return (
    <div 
      style={{
        width: '100%', 
        height: 'fit-content', 
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'flex-end',
        padding: '10px 16px',
      }}
    >  
      <div 
        style={{
          width: 'fit-content', 
          height: 'fit-content', 
          border: '1px solid #e1e1e1', 
          borderRadius: '10px', 
          padding: '10px', 
          paddingRight: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <div>
          <label className="h5 fc-gray-600">{fields[0].label}</label>
          <div className="spacing-4" />
          <input 
            type="text" 
            className={styles.PreQuestion__input}
            placeholder={fields[0].placeholder}
            value={firstInput}
            onChange={handleFirstInputChange}
            onKeyDown={handleKeyPress}
            onFocus={() => sendInputFocusStatus(true)}
          />
        </div>
        {!inputValid[0] && firstInput && errorMessage[0] && (
          <>
            <div className={styles.PreQuestion__warning}>
              <img src='/img/units/cancel.png' alt='cancel' width={16} height={16} />
              <p className='h9 fc-warning'>{errorMessage[0]}</p>
            </div>
          </>
        )}
        
        <div>
          <label className="h5 fc-gray-600">{fields[1]?.label}</label>
          <div className="spacing-4" />
          <input 
            type="text" 
            className={styles.PreQuestion__input}
            placeholder={fields[1].placeholder}
            value={secondInput}
            onChange={handleSecondInputChange}
            onKeyDown={handleKeyPress}
            onFocus={() => sendInputFocusStatus(true)}
          />
        </div>

        {!inputValid[1] && secondInput && errorMessage[1] && (
          <>
            <div className={styles.PreQuestion__warning}>
              <img src='/img/units/cancel.png' alt='cancel' width={16} height={16} />
              <p className='h9 fc-warning'>{errorMessage[1]}</p>
            </div>
          </>
        )}
      </div>
      <button 
        onClick={handleButtonClick}
        className={inputValid[0] && inputValid[1] ? styles.PreQuestion__submitButton : styles.PreQuestion__submitButton__disabled}
      >
        <p className="h1 fc-white">입력 완료</p>
      </button>
    </div>
  );
};
